module.exports = __webpack_public_path__ + "static/media/bookgif.842b36b0.gif";